import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSketch20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSketch20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="m10.038 3.002 4.393.508c.093.01.177.06.233.137l3.27 4.51a.35.35 0 0 1-.015.428l-7.79 9.354a.166.166 0 0 1-.257 0L2.08 8.586a.35.35 0 0 1-.014-.429l3.27-4.51a.34.34 0 0 1 .233-.136l4.393-.508a.3.3 0 0 1 .076 0m.912.973a.07.07 0 0 0-.096-.005.074.074 0 0 0-.016.094l.006.008L13.32 7.23c.024.03.037.069.037.108a.17.17 0 0 1-.154.172H6.81a.17.17 0 0 1-.105-.038.175.175 0 0 1-.035-.23l.01-.012 2.477-3.157a.074.074 0 0 0-.006-.097.07.07 0 0 0-.093-.007l-.008.007L5.694 7.43a.13.13 0 0 1-.102.04.136.136 0 0 1-.128-.13v-.014l.116-2.501a.07.07 0 0 0-.053-.07.07.07 0 0 0-.078.042l-.002.01-.636 2.879a.27.27 0 0 1-.188.204l-.018.004-1.575.347a.07.07 0 0 0-.053.068c0 .035.026.063.058.068h1.58c.092 0 .176.048.226.126l.01.015 3.767 6.88a.1.1 0 0 0 .131.043.104.104 0 0 0 .053-.127l-.004-.01L5.75 8.67a.2.2 0 0 1-.019-.088c0-.109.083-.198.188-.206h8.146q.045 0 .086.02c.096.046.14.16.102.26l-.005.014-3.047 6.631a.105.105 0 0 0 .042.134.1.1 0 0 0 .132-.03l.006-.01 3.768-6.879a.27.27 0 0 1 .216-.14h1.589c.032 0 .06-.023.066-.055a.07.07 0 0 0-.043-.079l-.008-.003-1.575-.347a.27.27 0 0 1-.201-.19l-.005-.018-.636-2.88a.07.07 0 0 0-.069-.054.07.07 0 0 0-.064.063v.01l.116 2.501a.14.14 0 0 1-.04.104.13.13 0 0 1-.18.01l-.01-.01z"
            />
        </svg>
    );
}
export default memo(IconSketch20);
